/** Les hôtes dont la racine sert la vitrine du produit, jamais un théâtre. */
export function estHoteMarketingConnu(hote: string): boolean {
  return /^(?:www\.ridomio\.(?:ch|fr|com)|ticket\.ilygo\.ch|tickets\.uat\.ilygo\.ch)$/iu.test(hote)
}
